import Env from '../base/env'
import MainThreeScene from "../webgl/canvasA/MainThreeScene"
import Circles2DMain from "../webgl/canvasB/circles-2d-main"
import { lerp } from '../vendor/utils'

export default class CanvasAnim
{
  constructor()
  {
    this.DOM = {
      canvasA:document.querySelector('.jsCanvasA'),
      canvasB:document.querySelector('.jsCanvasB'),
    }
    this.DOM.parentCanvasB = this.DOM.canvasB.parentElement
    this.VARS = {
      raf:false,
      canvasA:{
        duration:6,
        nbSteps:6,
        progress:0,
        lastProgress:0
      },
      canvasB:{
        duration:6,
        nbSteps:4,
        progress:0,
        lastProgress:0
      }
    }
    //
    this.setup()
  }

  initCanvasA()
  {
    const viewport = Env.framework.toolbox.getViewport().width

    MainThreeScene.init(this.DOM.canvasA)
    if(viewport.width > 1600) {
      MainThreeScene.camera.position.z = 20
    }
    if(viewport.width > 1900) {
      MainThreeScene.camera.position.z = 17
    }
    if(Env.mobileCSS == true) {
      MainThreeScene.camera.position.z = 35
    }


  }

  initCanvasB()
  {
    if(Env.mobileCSS) {
      Circles2DMain.params.circleSet0.finalRadius = 300
      Circles2DMain.params.circleSet0.posIncOffset = 50
      Circles2DMain.params.circleSet0.posOffset = 50
    }
    Circles2DMain.init(this.DOM.canvasB)
  }

  renderCanvas()
  {

    const viewportReference = Env.framework.toolbox.getViewport().height * 1.3

    //? Scroll Position A
    const totalAScrollY = viewportReference * ( this.VARS.canvasA.nbSteps - 0)
    let progressA = Env.framework.UI.VARS.smooth.scrolltop / totalAScrollY
    if(progressA > 1) {
      progressA = 1
    }
    //? Scroll Position B
    const totalBScrollY = viewportReference * ( this.VARS.canvasB.nbSteps - 0)
    const scrollBPos = (Env.framework.UI.VARS.smooth.scrolltop - (totalAScrollY - 0))
    let progressB = scrollBPos / (totalBScrollY)
    if(progressB > 1) {
      progressB = 1
    } else if(progressB < 0) {
      progressB = 0
    }

    //? Toggle Canvas
    if(Env.framework.UI.VARS.smooth.scrolltop > totalAScrollY) {
      this.DOM.canvasA.classList.remove('canvas-enabled')
      this.DOM.parentCanvasB.classList.add('canvas-enabled')
    } else {
      this.DOM.canvasA.classList.add('canvas-enabled')
      this.DOM.parentCanvasB.classList.remove('canvas-enabled')
    }

    //? Update progress A
    const seekA = progressA * this.VARS.canvasA.duration
    this.VARS.canvasA.progress = seekA
    this.VARS.canvasA.lastProgress = lerp(this.VARS.canvasA.lastProgress || this.VARS.canvasA.progress, this.VARS.canvasA.progress, .05);
    //? Render A
    MainThreeScene.update()
    MainThreeScene.progress = this.VARS.canvasA.lastProgress

    //? Update progress B
    const seekB = progressB * this.VARS.canvasB.duration
    this.VARS.canvasB.progress = seekB
    this.VARS.canvasB.lastProgress = lerp(this.VARS.canvasB.lastProgress || this.VARS.canvasB.progress, this.VARS.canvasB.progress, .05);

    //? Render B
    Circles2DMain.update()
    Circles2DMain.tlTime = this.VARS.canvasB.lastProgress

  }

  watcher()
  {
    this.VARS.raf = requestAnimationFrame(()=>{

      this.renderCanvas()
      this.watcher()
    })
  }

  setup()
  {
    this.initCanvasA()
    this.initCanvasB()
    this.watcher()
  }

}
